import { Component } from '@angular/core';

import { BaseIconComponent } from '../base-icon.component';

@Component({
  selector: 'app-travel-insurance-icon',
  template: `
    <svg
      [attr.width]="width"
      [attr.height]="height"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M15.3911 5.89999L10.9311 3.64099C10.7786 3.56493 10.6105 3.52533 10.4401 3.52533C10.2697 3.52533 10.1016 3.56493 9.94908 3.64099L8.10008 4.55399C7.93308 4.63768 7.79014 4.76253 7.68475 4.91675C7.57935 5.07097 7.51496 5.24949 7.49765 5.43548C7.48034 5.62147 7.51068 5.80881 7.58581 5.97983C7.66094 6.15085 7.77839 6.29992 7.92708 6.41299L10.5001 8.36799"
        stroke="#00D5D3"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M18.6679 4.24002L6.03792 10.623L4.07892 9.14502L1.97892 10.07C1.81664 10.1512 1.67695 10.2712 1.5723 10.4194C1.46764 10.5676 1.40127 10.7394 1.3791 10.9194C1.35692 11.0995 1.37963 11.2823 1.4452 11.4514C1.51078 11.6206 1.61717 11.7709 1.75492 11.889L5.74992 15.289C6.07635 15.5691 6.47799 15.7468 6.90477 15.8002C7.33155 15.8535 7.76459 15.7801 8.14992 15.589L11.7699 13.789V19.376C11.7673 19.5621 11.8127 19.7457 11.9016 19.9092C11.9905 20.0727 12.1199 20.2106 12.2775 20.3097C12.4351 20.4087 12.6155 20.4655 12.8014 20.4747C12.9872 20.4839 13.1724 20.4451 13.3389 20.362L15.2199 19.429C15.364 19.3573 15.4907 19.2549 15.5909 19.129C15.6911 19.003 15.7625 18.8566 15.7999 18.7L17.6699 10.862L21.1109 9.15502C21.4336 8.99461 21.7216 8.77221 21.9584 8.50051C22.1952 8.22881 22.3761 7.91313 22.4909 7.5715C22.6056 7.22988 22.652 6.86899 22.6273 6.50945C22.6026 6.1499 22.5073 5.79874 22.3469 5.47602C22.1865 5.1533 21.9641 4.86533 21.6924 4.62856C21.4207 4.39179 21.105 4.21085 20.7634 4.09607C20.4218 3.9813 20.0609 3.93494 19.7013 3.95964C19.3418 3.98434 18.9906 4.07961 18.6679 4.24002Z"
        [attr.stroke]="color"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  `,
})
export class TravelInsuranceIconComponent extends BaseIconComponent {}
